import { Component, OnInit } from '@angular/core';
import { Utilservice } from '@core/services/util.service';
import { VisitasService } from '@modules/visitas/services/visitas.service';
import { User } from '@shared/models';
import { max } from 'lodash';
import * as moment from 'moment';
import * as toastr from 'toastr'

@Component({
  selector: 'app-status-sem-agendamento',
  templateUrl: './status-sem-agendamento.component.html',
  styleUrls: ['./status-sem-agendamento.component.css']
})
export class StatusSemAgendamentoComponent implements OnInit {

  constructor(private visitService: VisitasService) { }

  lsStatusVisita: any[] = [];
  lsStatusSemCliente: any[] = [];

  isRequesting: boolean = false;

  cnpj: string;
  selectedStatus: string;

  userLogado: User;

  mindate;



  myFilter = {
    dataSelecionada: "",
    status: "",
    cnpj: "",
    cdfzs:"",
    setor:0,
    idVnd:0
  };

  ngOnInit() {
    const user = localStorage.getItem("user_logado");
    this.userLogado = JSON.parse(user);

    this.getStatus();

    this.getListStatusSemVisita();

    this.mindate = moment().format("YYYY-MM-DD");
  }

  getStatus() {
    this.visitService
      .getStatusVisita()
      .subscribe(
        data => (this.lsStatusVisita = data),
        error => console.log(error)
      );
  }

  filterStatus(status) {
    this.myFilter.status = this.selectedStatus.toString();
  }

  saveStatusSemAgendamento(){

    this.myFilter.cdfzs = this.userLogado.setor;
    this.myFilter.setor = this.userLogado.idSetor;
    this.myFilter.idVnd = this.userLogado.id;

    if(this.myFilter.cnpj == ""){
      toastr.error('Campo "CNPJ" é obrigatório!');
      return;
    }

    if(this.myFilter.dataSelecionada == ""){
      toastr.error('Campo "DATA STATUS" é obrigatório!');
      return;
    }

    if(this.myFilter.status == ""){
      toastr.error('Campo "STATUS" é obrigatório!');
      return;
    }

    this.visitService.saveStatusSemAgendamento(this.myFilter).subscribe(
      resp=> {
              toastr.success("Status sem agendamento salvo!");
              this.getListStatusSemVisita();
            },
      error => {
              toastr.error(error)
            }
    )
  }

  getListStatusSemVisita() {
    this.isRequesting = true;

    // const parametersVendedor = { ...this.parameters2 };

    if(this.userLogado.setor != undefined){

      let filtro = {
        setor: this.userLogado.idSetor,
      }
        // parametersVendedor.vendedor = parametersVendedor.vendedor.setor;

      this.visitService.getListStatusSemVisita(filtro).subscribe(
        data => {
          this.isRequesting = false;

          this.lsStatusSemCliente = data;
        },
        error => console.log(error)
      );
    }
  }

  formatCnpj(v) {
    return Utilservice.formatCnpj(v);
  }



}
